module.exports = __webpack_public_path__ + "img/1-2.c9268aa3.png";